// extracted by mini-css-extract-plugin
export default {"group_container":"GroupQuestions_group_container__otUBg","group_name":"GroupQuestions_group_name__FJIZq"};